export const validationErrors = {
  emptyStringError: `This field should not be empty`,
  urlValidationError: `The URL for assertion criteria must be the URL provided by ClinVar. Contact clinvar@ncbi.nlm.nih.gov if you need to find this URL or if you need to submit new assertion criteria.`,
  dateValidationError: `Invalid date format. Please use the YYYY-MM-DD format. If only month/year is known, use the first day of the month. If only year is known, use Jan. 1. Example dates: 2020-02-11, 1999-11-01`,
  numericalValidationError: `Please use integer values that equal or greater than 0.`,
  numberValidationError: `Please use numbers that are bigger than 0. (e.g: 2, 2.54, 12 ...)`,
};
